import * as storage from "utils/local-storage";
import { GROUP_SLUG, TOKEN, USER_ID, REFRESH_TOKEN } from "./constants";
import { getPrefixPath } from "./backend-path-builders";
import * as Sentry from "@sentry/react";

const headers = () => {
  return {
    "x-user-id": storage.local.getItem(USER_ID) || "",
    "x-login-token": storage.local.getItem(TOKEN) || "",
    "x-refresh-token": storage.local.getItem(REFRESH_TOKEN) || "",
    "x-client-id": storage.local.getItem(GROUP_SLUG) || "",
  };
};

const groupSlug = () => {
  return "/" + storage.local.getItem(GROUP_SLUG);
};

const handleHttpError = async (response: Response, method: string, path: string, requestBody?: any) => {
  let responseBody;
  try {
    const text = await response.text();
    try {
      responseBody = JSON.parse(text);
    } catch {
      responseBody = text;
    }
  } catch {
    responseBody = null;
  }

  const error = new Error(`HTTP ${response.status}: ${response.statusText}`);

  // Mark this error as already reported to Sentry
  (error as any).sentryReported = true;
  (error as any).status = response.status;

  // Preserve response structure similar to Amplify errors
  (error as any).response = {
    status: response.status,
    statusText: response.statusText,
    data: responseBody,
    url: response.url
  };

  Sentry.captureException(error, {
    tags: {
      feature: 'http_client',
      http_method: method,
      http_status: response.status.toString()
    },
    extra: {
      url: response.url,
      path,
      method,
      status: response.status,
      statusText: response.statusText,
      responseBody,
      requestBody,
      userId: storage.local.getItem(USER_ID),
      groupSlug: storage.local.getItem(GROUP_SLUG)
    }
  });

  return error;
};

export const integratedGet = (path: string, options: any) => {
  const url = process.env.REACT_APP_BACKEND_URL + getPrefixPath() + groupSlug() + path;

  return fetch(url, {
    method: "GET",
    headers: headers(),
  }).then(async (res) => {
    if (!res.ok) {
      throw await handleHttpError(res, "GET", path);
    }
    return res.json();
  });
};

export const integratedPost = (path: string, options: any) => {
  const url = process.env.REACT_APP_BACKEND_URL + getPrefixPath() + groupSlug() + path;

  return fetch(url, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify(options?.body),
  }).then(async (res) => {
    if (!res.ok) {
      throw await handleHttpError(res, "POST", path, options?.body);
    }
    return res.json();
  });
};

export const integratedPut = (path: string, options: { body?: any }) => {
  const url = process.env.REACT_APP_BACKEND_URL + getPrefixPath() + groupSlug() + path;

  return fetch(url, {
    method: "PUT",
    headers: headers(),
    body: JSON.stringify(options?.body),
  }).then(async (res) => {
    if (!res.ok) {
      throw await handleHttpError(res, "PUT", path, options?.body);
    }
    return res.json();
  });
};
